<div [ngClass]="{
    'w-100 full-height-mobile position-relative z-max': !viewportService.isLargeViewPort(),
    'h-100': viewportService.isLargeViewPort()}"
    class="d-flex flex-column w-100 overflow-y-auto overflow-x-hidden no-scroll-bar background-white z-max">
    <div [ngClass]="{'w-100': !viewportService.isLargeViewPort(), 'width-400px': viewportService.isLargeViewPort()}"
         class="flex-none row m-0 p-2 background-primary-blue height-70px w-100 shadow z-max align-items-center">
        <div class="col-2">
            <div class="d-flex justify-content-center">
                <div (click)="back()" class="pointer text-reset">
                    <i class="color-white fa-solid fa-chevron-left fa-xl"></i>
                </div>
            </div>
        </div>
        <div class="col-8 m-auto">
            <div class="text-center color-white fs-lg">Add BLE scanner</div>
        </div>
        <div class="col-2">
            <div class="d-flex justify-content-center">
                <div (click)="close()" class="pointer text-reset">
                    <i class="color-white fa-solid fa-x fa-xl"></i>
                </div>
            </div>
        </div>
    </div>
    <div class="d-flex flex-column gap-3 p-3 w-100 background-white overflow-y-auto overflow-x-hidden no-scroll-bar">
        @if (existingDeviceAssociation()) {
            <div class="card p-3">
                Device '{{ deviceId() }}' is already associated with asset '{{ existingAsset()?.name }}'.
                Do you want to remove this association?
            </div>
            <div class="d-flex flex-column gap-2">
                <app-generic-button
                    (click)="deleteDeviceAssociation()"
                    description="Remove existing proximity-sample point association"
                    [alwaysShowText]="true"
                    [buttonClass]="'btn-danger btn-danger-shadow'"
                    [buttonText]="'Remove association'"
                    [primaryIcon]="'fa-solid fa-trashcan'"/>
                <app-generic-button
                    (click)="reset()"
                    description="Cancel addition of proximity-sample point"
                    [alwaysShowText]="true"
                    [buttonClass]="'btn-info'"
                    [buttonText]="'Cancel'"/>
            </div>
        } @else if (!store.deviceToMatch()) {
            <app-device-id-input
                (deviceIdSelected)="onDeviceIdSelected($event)"
                [deviceName]="'device'"
                [inputLength]="5"
                [showImage]="false" />
        } @else if (!store.onboardingAction()) {
            <div class="d-flex flex-column gap-2">
                <div class="fw-bold">Associated device ID: {{ deviceId() }}</div>
                <app-generic-button
                    (click)="setOnboardingAction(OnboardingAction.associateToExistingAsset)"
                    description="Associate BLE scanner to existing asset"
                    [alwaysShowText]="true"
                    [buttonClass]="'btn-info'"
                    [buttonText]="'Associate to existing asset'"/>
                <app-generic-button
                    (click)="setOnboardingAction(OnboardingAction.createNewAsset)"
                    description="Create new asset for BLE scanner"
                    [alwaysShowText]="true"
                    [buttonClass]="'btn-info'"
                    [buttonText]="'Create new asset'"/>
                <app-generic-button
                    (click)="reset()"
                    description="Cancel adding new proximity-sample point"
                    [alwaysShowText]="true"
                    [buttonClass]="'btn-info'"
                    [buttonText]="'Cancel'"/>
            </div>
        } @else if (store.onboardingAction() === OnboardingAction.associateToExistingAsset) {
            <div class="d-flex flex-column gap-2">
                <div class="fw-bold">Associated device ID: {{ deviceId() }}</div>
                @for (proximitySamplePoint of fixedSamplePointsStore.proximitySamplePoints(); track proximitySamplePoint.id) {
                    <div
                        (click)="associate(proximitySamplePoint.id)"
                        class="d-flex rounded-2 background-light-gray p-2 gap-2 pointer pointer-hover-blue">
                        <app-bluetooth-svg [status]="ProximitySamplePointStatus.ONLINE" class="img-fluid img-max px-2"></app-bluetooth-svg>
                        <div class="d-flex flex-column justify-content-center">
                            <div class="fw-bold text-truncate">{{ proximitySamplePoint.name }}</div>
                        </div>
                    </div>
                }
                @for (precipitationSamplePoint of fixedSamplePointsStore.precipitationSamplePoints(); track precipitationSamplePoint.id) {
                    <div
                        (click)="associate(precipitationSamplePoint.id)"
                        class="d-flex rounded-2 background-light-gray p-2 gap-2 pointer pointer-hover-blue">
                        <app-precipitation-svg [online]="true" class="img-fluid img-max px-2"></app-precipitation-svg>
                        <div class="d-flex flex-column justify-content-center">
                            <div class="fw-bold text-truncate">{{ precipitationSamplePoint.name }}</div>
                        </div>
                    </div>
                }
                <app-generic-button
                    (click)="reset()"
                    description="Cancel adding new proximity-sample point"
                    [alwaysShowText]="true"
                    [buttonClass]="'btn-info'"
                    [buttonText]="'Cancel'"/>
            </div>
        } @else if (store.onboardingAction() === OnboardingAction.createNewAsset) {
            <div class="d-flex flex-column gap-3">
                <div class="fw-bold">Associated device ID: {{ deviceId() }}</div>
                <div class="input-group">
                    <input (input)="setName($event)"
                            [ngClass]="{'is-invalid': store.name() === undefined}"
                            [value]="store.name() || ''"
                            class="form-control m-auto"
                            placeholder="Name"
                            required
                            type="text">
                </div>
                <div class="d-flex gap-3">
                    <div class="input-group">
                        <input (input)="setLat($event)"
                                [ngClass]="{'is-invalid': store.lat() === undefined}"
                                [value]="store.lat() || ''"
                                class="form-control m-auto"
                                placeholder="Latitude"
                                required
                                type="number">
                    </div>
                    <div class="input-group">
                        <input (input)="setLong($event)"
                                [ngClass]="{'is-invalid': store.long() === undefined}"
                                [value]="store.long() || ''"
                                class="form-control m-auto"
                                placeholder="Longitude"
                                required
                                type="number">
                    </div>
                </div>
            </div>

            <app-generic-button
                (click)="onDropAPin()"
                description="Drop a pin of proximity-sample point"
                [alwaysShowText]="true"
                [buttonText]="'Drop a pin'"
                [disabled]="loading()"
                [primaryIcon]="'fa-solid fa-pin'"/>

            <app-switch
                [checked]="store.sampleBasedLocation()"
                (change)="toggleSampleBasedLocation()"
                label="Show latest reported GPS position on map"/>

            <app-generic-button
                (click)="processNewAsset()"
                description="Add proximity-sample point"
                [alwaysShowText]="true"
                [buttonText]="'Add'"
                [disabled]="!canProcessNewAsset()"
                [loading]="loading()"
                [primaryIcon]="'fa-solid fa-check'"/>

            <app-generic-button
                (click)="reset()"
                description="Cancel adding new proximity-sample point"
                [alwaysShowText]="true"
                [buttonClass]="'btn-info'"
                [buttonText]="'Cancel'"/>
        }
    </div>
</div>
